import i18n from '../../../i18n.config';
import { ServiceCategory } from './service-categories-types';

export const getKzServiceCategoryList = (): ServiceCategory[] => [
  {
    topCategoryId: 2134,
    topCategoryName: i18n.t('instore-section.tinting-title'),
    topCategoryType: "INSTORE",
    topCategoryUrl: "/uslugi/kolerovka",
  },
  {
    topCategoryId: 2136,
    topCategoryName: i18n.t('instore-section.sewing-curtains-title'),
    topCategoryType: "INSTORE",
    topCategoryUrl: "/uslugi/poshiv-shtor",
  },
  {
    topCategoryId: 2137,
    topCategoryName: i18n.t('instore-section.wood-processing-title'),
    topCategoryType: "INSTORE",
    topCategoryUrl: "/uslugi/rezka-dereva",
  },
];
